import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import { DocumentWorkflowCounterparty } from '@dealstack/shared/lib/generated';

export const formatDocumentWorkflowCounterparties = (
	counterparties: DocumentWorkflowCounterparty[] | undefined | null,
	separator = ', '
): string => {
	if (!Array.isArray(counterparties) || counterparties.length === 0) {
		return LONG_DASH;
	}
	const names = counterparties.map((cp) => cp.name).filter(Boolean);
	return names.length > 0 ? names.join(separator) : LONG_DASH;
};
